var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "",
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#8eb1d3",
    style: {},
    "data-original": "#ff314f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m275.17 511.29c131.43-9.728 235.23-118.69 236.8-252.24l-122.62-122.62-6.244 9.161-31.384-31.384-13.54 18.822 31.808 31.808-57.923 84.98-135.61-135.61-13.972 58.039 41.681 40.443-76.207 151.77 147.21 146.83z",
    fill: "#8eb1d3",
    style: {},
    "data-original": "#a30f44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m371.23 369.78h-230.46c-10.004 0-18.115-8.109-18.115-18.115v-181.9h266.68v181.9c1e-3 10.006-8.109 18.115-18.112 18.115z",
    fill: "#fff",
    style: {},
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m255.43 169.76v200.01h115.8c10.004 0 18.115-8.111 18.115-18.115v-181.9h-133.92z",
    fill: "#d0d1d3",
    style: {},
    "data-original": "#d0d1d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.66 136.43h266.69v66.67h-266.69z",
    fill: "#fee187",
    style: {},
    "data-original": "#fee187"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m255.43 136.43h133.91v66.67h-133.91z",
    fill: "#ffc61b",
    style: {},
    "data-original": "#ffc61b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m160.29 114.21h16.163v44.447h-16.163zm175.27 0h16.163v44.447h-16.163z",
    fill: "#386895",
    style: {},
    "data-original": "#386895"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m144.58 222.82h28.444v28.444h-28.444zm48.597 0h28.444v28.444h-28.444zm48.597 0h13.648v28.444h-13.648zm13.653 0h14.796v28.444h-14.796z",
    fill: "#ff7f4f",
    style: {},
    "data-original": "#ff7f4f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m290.38 222.82h28.444v28.444h-28.444zm48.579 0h28.444v28.444h-28.444z",
    fill: "#d35933",
    style: {},
    "data-original": "#d35933"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m144.58 267.84h28.444v28.444h-28.444zm48.597 0h28.444v28.444h-28.444zm48.597 0h13.648v28.444h-13.648zm13.653 0h14.796v28.444h-14.796z",
    fill: "#ff7f4f",
    style: {},
    "data-original": "#ff7f4f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m290.38 267.84h28.444v28.444h-28.444zm48.579 0h28.444v28.444h-28.444z",
    fill: "#d35933",
    style: {},
    "data-original": "#d35933"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m144.58 312.89h28.444v28.444h-28.444zm48.597 0h28.444v28.444h-28.444zm48.597 0h28.444v28.444h-28.444z",
    fill: "#ff7f4f",
    style: {},
    "data-original": "#ff7f4f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m255.43 222.82h14.796v28.444h-14.796zm0 45.028h14.796v28.444h-14.796zm0 45.046h14.796v28.444h-14.796zm34.944 0h28.444v28.444h-28.444zm48.579 0h28.444v28.444h-28.444z",
    fill: "#d35933",
    style: {},
    "data-original": "#d35933"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.c9c0b36db81e2a609a2777b04aff2694.svg";
export { ForwardRef as ReactComponent };